import { ALL_ROUTES, PATIENT_TABLE_NAMES } from '@app/router';

/**
 * Builds the URL for the patient dashboard (default tab unless
 * overridden). Twin of `buildEditPatientPath` — resolves between the
 * DS view path and the regular view path based on whether
 * `accountUuid` is provided.
 *
 * Used by the patient-edit Back button as the explicit fallback when
 * history state is unavailable (page reload, entry points that do not
 * pass `fromDashboard`), so returning to the dashboard never depends
 * on the navigation stack.
 */
const buildPatientDashboardPath = ({
  accountUuid,
  currentAccountUuid,
  patientUuid,
  tableName = PATIENT_TABLE_NAMES.overview,
}) => {
  const template = accountUuid
    ? ALL_ROUTES.patient.dashboardDS.path
    : ALL_ROUTES.patient.dashboard.path;
  return template
    .replace(':currentAccountUuid', currentAccountUuid)
    .replace(':accountUuid', accountUuid || '')
    .replace(':patientUuid', patientUuid)
    .replace(':tableName', tableName);
};

export default buildPatientDashboardPath;
